import React, { forwardRef, ReactNode, Ref, useRef } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import { SlotWrapper, SlotWrapperProps } from './SlotWrapper';
import { StyledTextField } from './TextFieldSlot';
import { useEnrollSlotRef } from './hooks';
import { SlotRef } from './types';

interface TextFieldSlotProps extends SlotWrapperProps {
  readOnly?: boolean;
  placeholder?: string;
  value: string;
  disabled?: boolean;
  onChange: (e: string) => void;
  onBlur?: () => void;
  children?: ReactNode;
}

export const InternationalTelecomFieldSlot = forwardRef(
  (
    {
      readOnly,
      placeholder,
      value,
      disabled,
      onChange,
      onBlur,
      children,
      ...slotWrapperProps
    }: TextFieldSlotProps,
    ref: Ref<SlotRef>,
  ) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const inputRef = useRef(null);
    useEnrollSlotRef({ ref, wrapperRef, inputs: [inputRef.current] });

    return (
      <SlotWrapper ref={wrapperRef} {...slotWrapperProps}>
        <PhoneInput
          className="input-phone-number"
          inputRef={inputRef}
          defaultCountry="KR"
          value={value}
          onChange={v => {
            onChange(v === undefined ? '' : `${v}`);
          }}
          readOnly={readOnly}
          disabled={disabled}
          inputComponent={StyledTextField}
          placeholder={placeholder}
          onBlur={onBlur}
        />
        {children}
      </SlotWrapper>
    );
  },
);
